module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fpf07"))).then(() => parcelRequire('d0iPb'));